// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type MyBalanceChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MyBalanceChangedSubscription = { bankingMyBalanceChanged: { clientSubscriptionId: string | undefined, changedBalance: { id: string, currency: string | undefined, totalBalance: number | undefined, totalBonusBalance: number | undefined, realBalance: number | undefined, cashierBalance: number | undefined } | undefined } | undefined };


export const MyBalanceChangedSubscriptionDocument = gql`
    subscription MyBalanceChangedSubscription {
  bankingMyBalanceChanged(input: {  }) {
    changedBalance {
      id
      currency
      totalBalance
      totalBonusBalance
      realBalance
      cashierBalance
    }
    clientSubscriptionId
  }
}
    `;